<template>
        <div class="card-container" @click="recto = !recto">
            <transition name="flip-fade">
                <div v-if="recto" class="front"><p class="cardtext">Vrai ou Faux ?<br>{{frontText }}</p></div>
            </transition>
            <transition name="flip-fade">
                <div v-if="!recto" class="back"><p class="cardtext">{{ backText }}</p>
                </div>
            </transition>
        </div>
</template>

<script>
    export default {
        name: "Card",
        props: {
            frontText: String,
            backText: String,
        },
        data(){
            return{
                recto: true
            }

        }
    };
</script>

<style>
    .card-container,
    .front,
    .back {
        width: 90vw;
        max-width: 500px;
        height: 90vw;
        max-height: 500px;
    }

    .card-container {
        position: relative;
    }

    .front,
    .back {
        position: absolute;
        border-radius: 5%;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0px 0px 8px 1px rgba(150, 150, 150, 1);

    }

    .front {
        background: rgb(183, 255, 205);
        background: linear-gradient(135deg, rgba(183, 255, 205, 1) 0%, rgba(107, 255, 152, 1) 100%);
    }

    .back {
        background: rgb(183, 233, 255);
        background: linear-gradient(135deg, rgba(183, 233, 255, 1) 0%, rgba(107, 210, 255, 1) 100%);
    }

    .flip-fade-enter-active,
    .flip-fade-leave-active {
        transition: all .3s ease;
    }

    .flip-fade-enter, .flip-fade-leave-to
    {
        transform: rotateY(180deg);
        opacity: 0;
    }

    .cardtext {
        color: black;
        font-size: calc(13pt + 2vh);
        text-align: center;
        padding: 20px;
        line-height: 135%;
    }
</style>
